import { Link } from '@/components/atoms'

import { useNavigation } from '@/hooks'

const HomeRoute = () => {
  const navigation = useNavigation()

  return (
    <div className="flex flex-col">
      <div className="mt-10 flex flex-row justify-between p-8">
        <div className="text-4xl font-bold text-slate-800">Overview</div>
      </div>

      <Link
        className="m-2 rounded-md bg-slate-400 p-2 hover:bg-slate-200 hover:text-slate-400"
        onClick={() => {
          navigation.goTo('/users')
        }}
      >
        to user list →
      </Link>
    </div>
  )
}
HomeRoute.layouts = 'content'
HomeRoute.displayName = 'HomeRoute'
export default HomeRoute
